import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export default function SuccessForm(): ReactElement {
  const { t } = useTranslation();
  return (
    <Grid container justifyContent="center" className="fake-form success-message">
      <Grid size={{ xs: 12, md: 8 }}>
        <Typography variant="h6">{t("Le formulaire a été soumis avec succès.")}</Typography>
        <Typography variant="h4">
          {t("Thank you, an advisor will contact you very soon!")}
        </Typography>
      </Grid>
    </Grid>
  );
}
